// extracted by mini-css-extract-plugin
module.exports = {"root":"container_root__34TYh","hasCheckbox":"container_hasCheckbox__2BW6F","footer":"container_footer__1fsqn"};